import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { IonModal, IonHeader, IonFooter, IonContent } from '@ionic/react'
import i18n from 'i18next'
import './index.scss'

interface IProps {
  info: any;
  reject?: () => void;
  resolve?: () => void;
}

const MergeModal: FC<IProps> = (props: IProps) => {
  const {
    info,
    reject,
    resolve,
  } = props
  return (
    <IonModal
      cssClass='merge-modal'
      isOpen
      showBackdrop
      swipeToClose
      backdropDismiss
      onDidDismiss={reject}
    >
      <IonHeader className='modal-header'>
        <span>{i18n.t('mkt.member.accountMerger')}</span>
      </IonHeader>
      <IonContent>
        <div className='modal-content'>
          <span>{info.type === 'mobile' ? i18n.t('mkt.member.merge1', { countryCode: info.countryCode, mobile: info.account }) : i18n.t(`mkt.member.merge${window.bo === 'cn' ? 3 : 2}`, { email: info.account })}</span>
        </div>
      </IonContent>
      <IonFooter>
        <div className='modal-footer'>
          <div className='btn cancel' data-cypid='mergeModalClose' onClick={reject}>
            <span>{i18n.t('common.cancel')}</span>
          </div>
          <div className='btn confirm' data-cypid='mergeModalConfirm' onClick={resolve}>
            <span>{i18n.t('common.ok')}</span>
          </div>
        </div>
      </IonFooter>
    </IonModal>
  )
}

export default observer(MergeModal)
